<template>
  <el-dialog title="显示字段" :show-close="false" :append-to-body="true" :close-on-click-modal="false" v-model="visible" width="578px">
    <div>
      <div style="margin-bottom: 20px;">
        <el-checkbox-group v-model="checkLi">
          <el-checkbox v-for="item in fieldLi" :key="item.value" :label="item.revisabilityName || item.name" />
        </el-checkbox-group>
      </div>
      <div style="text-align: right;">
        <el-button size="mini" type="primary" @click="confirm">确定</el-button>
        <el-button size="mini" @click="visible = false">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { flattenTreeWithWhile } from '@/components/schoolInstrument/mixins/utils.js'
export default {
  // 组件名称
  name: 'checkField',
  // 组件参数 接收来自父组件的数据
  props: {
    tableStyleField: {
      type: Object,
      default: () => ({})
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {
      visible: false,
      fieldLi: [],
      checkLi: []
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    open(opt = {}) {
      this.fieldLi = []
      this.checkLi = []
      const { selectDatas } = opt
      const fieldLi = []
      const checkLi = []
      if (this.tableStyleField.filedType === 'pivot') {
        if (selectDatas) {
          for (const ele of selectDatas) {
            if (ele.list) {
              const li = flattenTreeWithWhile(ele, 'list')
              for (const cele of li) {
                const idx = fieldLi.findIndex(item => ((item.revisabilityName === cele.revisabilityName) || (item.name === cele.name)))
                if (idx === -1 && cele.name !== 'approving_id') {
                  fieldLi.push(cele)
                }
              }
            } else {
              fieldLi.push(ele)
            }
          }
          this.fieldLi = fieldLi
          for (const ele of fieldLi) {
            if (!ele.isHide) {
              checkLi.push(ele.revisabilityName || ele.name)
            }
          }
          this.checkLi = checkLi
        }
      } else {
        for (const ele of selectDatas) {
          if (ele.isAppenFeild !== false) {
            checkLi.push(ele.revisabilityName || ele.name)
          }
        }
        this.checkLi = checkLi
        this.fieldLi = selectDatas
      }
      this.visible = true
    },
    confirm() {
      const li = []
      for (const ele of this.fieldLi) {
        if (!this.checkLi.includes(ele.revisabilityName || ele.name)) {
          li.push(ele.revisabilityName || ele.name)
        }
      }
      this.$emit('checkField', li)
      this.visible = false
    },
  },
}
</script> 

<style scoped lang="scss">

</style>
